<template>
  <div>
  <div class="black-overlay"></div>
  <div class="modal modal--welcomeback modal--zero-balance" id="welcome_modal">
    <div class="modal__content">
      <button class="btn modal-close"><i class="icon-close"></i></button>
      <div class="modal__header">
        <h1>{{ getTranslations.home_modals_zero_balance_zero_game_balance }}</h1>
        <img class="usericon" src="static/images/oops.svg" alt="">
      </div>
      <div class="modal__body">
        {{ getTranslations.home_modals_zero_balance_unlock_more_games_msg }}
      </div>
      <div class="modal__footer">
        <a v-if="!hideStore"> <div class="btn2 btn2--std btn2--small btn2--fixed" @click.prevent="toBundlesPage">{{ getTranslations.home_modals_zero_balance_unlock_games }}</div></a>
      </div>
    </div>
  </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'zero-balance',
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ZeroBalance.vue